import { lazyNamed } from 'src/utils/lazyNamed.ts';
import { Advertisers } from './pages/Advertisers/index.ts';
import { Campaigns } from './pages/Campaigns/index.ts';
import { Creatives } from './pages/Creatives/index.ts';
import { CreativesApproval } from './pages/CreativesApproval/index.ts';
import { Invoicing } from './pages/Invoicing/index.ts';
import { PaymentMethods } from './pages/PaymentMethods/index.ts';
import { Receipts } from './pages/Receipts/index.ts';
import { ScreenshotManagement } from './pages/ScreenshotManagement/index.ts';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  Dashboard: lazyNamed(() => import('./pages/Dashboard/index.tsx'), 'Dashboard'),
  Campaigns,
  Positions: lazyNamed(() => import('./pages/Positions/index.tsx'), 'Positions'),
  Advertisers,
  Creatives,
  CreativesApproval,
  ScreenshotManagement,
  Receipts,
  Invoicing,
  PaymentMethods,
};
